"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * It gets cookie value using cookie name
 * @param cName cookie Name
 * @returns {string} cookie Value
 */
const getCookie = (cName) => {
    let cValue = document && document.cookie ? document.cookie : '';
    if (cValue) {
        let cStart = cValue.indexOf(` ${cName}=`);
        if (cStart === -1) {
            cStart = cValue.indexOf(`${cName}=`);
        }
        if (cStart === -1) {
            cValue = '';
        }
        else {
            cStart = cValue.indexOf('=', cStart) + 1;
            let cEnd = cValue.indexOf(';', cStart);
            if (cEnd === -1) {
                cEnd = cValue.length;
            }
            cValue = unescape(cValue.substring(cStart, cEnd));
        }
    }
    return cValue;
};
exports.default = getCookie;
//# sourceMappingURL=index.js.map